import React from "react";

import MapaComparativo from "./MapaComparativo.js";
import { Transition, chipIntento, coordenadasValidas, renglonDato, galeria } from "./comunes.js";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

// Modal de SOLO LECTURA de un intento de entrega: datos del acto (fecha, sucursal,
// reparto, repartidor, unidad), motivo, observaciones, coordenadas, galeria de fotos
// (autorizar/intentos/{id}/foto/{n}) y mapa con el punto donde el chofer lo registro.
// `intento` null = cargando (CircularProgress).
function IntentoDetalle(props) {
    const { open, onClose, intento } = props;

    const classes = useStyles();

    const punto = intento == null ? null : coordenadasValidas(intento.lat, intento.lon);
    const tituloIntento = intento == null ? "" : "Intento " + intento.numero + " de " + (intento.maximo || 2);

    return (
        <Dialog
            open={open} TransitionComponent={Transition} keepMounted onClose={onClose} maxWidth="md" fullWidth
            // mismo patron que el modal de solicitudes: el SweetAlert de error del modulo
            // puede montarse ENCIMA de este Dialog; sin esto el TrapFocus de MUI le roba el foco
            disableEnforceFocus
        >
            <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid #f3f4f6" }}>
                <span style={{ fontSize: 16, fontWeight: 700 }}>
                    {intento == null ? "Intento de entrega" : tituloIntento + " · Guía " + intento.guia}
                </span>
                {intento == null ? null : <span style={{ marginLeft: 10 }}>{chipIntento(intento.numero, intento.maximo)}</span>}
            </DialogTitle>
            <DialogContent style={{ padding: "16px 20px 20px" }}>
                {intento == null ? (
                    <div style={{ textAlign: "center", padding: 40 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card>
                                <CardBody>
                                    <h4 className={classes.cardIconTitle} style={{ color: "#e65100" }}>Datos del intento</h4>
                                    {renglonDato("Fecha y hora", intento.fecha)}
                                    {renglonDato("Sucursal", intento.nombresucursal || intento.sucursal)}
                                    {renglonDato("Reparto", intento.folioreparto)}
                                    {renglonDato("Repartidor", intento.chofer)}
                                    {renglonDato("Unidad", intento.unidad)}
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card>
                                <CardBody>
                                    <h4 className={classes.cardIconTitle} style={{ color: "#c62828" }}>Motivo del intento</h4>
                                    {renglonDato("Motivo", intento.motivo)}
                                    {renglonDato("Observaciones", intento.observaciones)}
                                    {renglonDato("Coordenadas", (punto ? intento.lat + ", " + intento.lon : null))}
                                    <p style={{ margin: "8px 0 0" }}><strong>Fotos:</strong></p>
                                    {galeria("autorizar/intentos/" + intento.id + "/foto/", intento.fotos, "Foto del intento")}
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <MapaComparativo
                                key={"intento-" + intento.id}
                                puntos={punto == null ? [] : [{ ...punto, titulo: tituloIntento, icono: "mark" }]}
                                altura="350px"
                            />
                        </GridItem>
                    </GridContainer>
                )}
                <div style={{ width: "100%", textAlign: "center", marginTop: 10 }}>
                    <Button color="warning" onClick={onClose}>Cerrar</Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default IntentoDetalle;
